import { render, staticRenderFns } from "./FromPcBo.vue?vue&type=template&id=167f868c&"
import script from "./FromPcBo.vue?vue&type=script&lang=js&"
export * from "./FromPcBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports